/**
 * UC-11 extension: ActivatePolicy (player-initiated enforcement on a single policy)
 */
import type { Policy } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface ActivatePolicyInput {
  policyId: string;
}

export interface ActivatePolicyOutput {
  ok: boolean;
  policy?: Policy;
  error?: string;
}

export interface ActivatePolicyDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class ActivatePolicyUseCase {
  constructor(private readonly deps: ActivatePolicyDependencies) {}

  execute(input: ActivatePolicyInput): ActivatePolicyOutput {
    try {
      const policy = this.deps.policyManager.enforcePolicy(input.policyId);

      this.deps.logger?.log('debug', 'policy.activated', { policyId: policy.id });

      return { ok: true, policy };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return { ok: false, error: message };
    }
  }
}